
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Helmet } from 'react-helmet';
import { useLanguage } from '@/hooks/useLanguage';
import { CVEFeed } from '@/components/cve/CVEFeed';

const CVE = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>{t('cve.title')} | Cybermonit</title>
      </Helmet>
      <Navbar />
      <main className="flex-grow">
        <CVEFeed />
      </main>
      <Footer />
    </div>
  );
};

export default CVE;
